(function () {
  class ReelSpinnerVisualSCS extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      dynamicSpinner,
      nudgeReel
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp,
        dynamicSpinner,
        nudgeReel
      );

      this._reelId = parseInt(reelId.replace("reel", ""));

      this._backgrounds = [];
      this._cashOverlays = [];
      this._multiplierOverlays = [];
      this._fishDataOnReel = [];
      this._fishermanDataOnReel = [];
      this._showMultiplier = true;
    }

    showMultiplier(show) {
      this._showMultiplier = show;
    }

    createBackgrounds() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let background = resourceManager.createObject(
          "sprite",
          `background:reel${this._reelId}:row${i}`,
          gfxObject.background,
          { fileName: "Symbols/Fish_Symbol_Background.png", anchor: 0.5, y: 12 }
        );

        let backgroundGolden = resourceManager.createObject(
          "sprite",
          `backgroundGolden:reel${this._reelId}:row${i}`,
          gfxObject.background,
          { fileName: "Symbols/GoldenPike_Symbol_Background.png", anchor: 0.5, y: 12 }
        );

        let backgrounds = {
          background,
          backgroundGolden,
        };

        background.visible = false;
        backgroundGolden.visible = false;
        this._backgrounds.push(backgrounds);
      }
    }

    createCashOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];
        let overlayText = resourceManager.createObject(
          "text",
          `cashOverlay:reel${this._reelId}:row${i}`,
          gfxObject.symbol.childContainer,
          {
            text: "???",
            fontDefinition: "cashFish",
            maxWidth: 140,
            anchor: 0.5,
            x: 0,
            y: 73,
          }
        );
        let overlayTextGrey = resourceManager.createObject(
          "text",
          `cashOverlayGrey:reel${this._reelId}:row${i}`,
          gfxObject.symbol.childContainer,
          {
            text: "???",
            fontDefinition: "cashFishGrey",
            maxWidth: 140,
            anchor: 0.5,
            x: 0,
            y: 73,
          }
        );
        overlayText.visible = false;
        overlayTextGrey.visible = false;
        let overlayTexts = {
          normal: overlayText,
          grey: overlayTextGrey,
        };
        this._cashOverlays.push(overlayTexts);
      }
    }

    createMultiplierOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();

      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let overlay = resourceManager.createObject("text", "multiplierOverlay", gfxObject.symbol.childContainer, {
          text: "",
          anchor: 0.5,
          fontDefinition: "fishermanMultiplier",
          anchor: 0.5,
          x: 42,
          y: -45,
        });

        overlay.visible = false;
        this._multiplierOverlays.push(overlay);
      }
    }

    getReelSymbol(index) {
      let symbolData = this._reelSpinnerData.getSymbolData();
      return symbolData[index].symId;
    }

    startDynamicSpin() {
      super.startDynamicSpin();
      this._fishDataOnReel = [];
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);

      let stake = gameController.getCurrentModeStake();

      for (let i = 0; i < ids.length; ++i) {
        let value = 0;
        let multiValue = 0;
        let symId = ids[i];
        let overlay = this._cashOverlays[i];
        let background = this._backgrounds[i];
        let multiOverlay = this._multiplierOverlays[i];

        overlay.normal.visible = false;
        overlay.grey.visible = false;
        background.background.visible = false;
        background.backgroundGolden.visible = false;
        multiOverlay.visible = false;

        switch (symId) {
          case 33:
            multiValue = 2;
            break;
          case 34:
            multiValue = 3;
            break;
          case 35:
            multiValue = 5;
            break;
          case 36:
            multiValue = 10;
            break;

          //Golden Pikes
          case 5:
            value = 100;
            break;
          case 23:
            value = 200;
            break;
          case 24:
            value = 500;
            break;
          case 25:
            value = 5000;
            break;

          //Regular Old Pikes
          case 6:
            value = 25;
            break;
          case 26:
            value = 35;
            break;
          case 27:
            value = 50;
            break;

          //Bass
          case 7:
            value = 15;
            break;
          case 28:
            value = 20;
            break;

          //Trout
          case 8:
            value = 8;
            break;
          case 29:
            value = 10;
            break;

          //Salmon
          case 9:
            value = 5;
            break;
          case 30:
            value = 6;
            break;

          //Carp
          case 10:
            value = 3;
            break;
          case 31:
            value = 4;
            break;

          //Minnow
          case 11:
            value = 1;
            break;
          case 32:
            value = 2;
            break;
        }

        if (value !== 0) {
          if (symId === 5 || symId === 23 || symId === 24 || symId === 25) {
            background.background.visible = false;
            background.backgroundGolden.visible = true;
          } else {
            background.background.visible = true;
            background.backgroundGolden.visible = false;
          }

          if (gameController.inFreeSpins || gameController.maxPlayActive) {
            overlay.grey.visible = false;
            overlay.normal.visible = true;
            overlay.normal.setText(gdk.formatCurrency(value * stake));
          } else {
            overlay.normal.visible = false;
            overlay.grey.visible = true;
            overlay.grey.setText(gdk.formatCurrency(value * stake));
          }
        }

        if (gameController.inFreeSpins && this._showMultiplier) {
          if (multiValue !== 0) {
            multiOverlay.setText("x" + multiValue);
            multiOverlay.visible = true;
          }
        }
      }
    }

    dimSymbol(row, showDim, duration) {
      super.dimSymbol(row, showDim, duration);

      const multiplierOverlay = this._multiplierOverlays[row];

      if (showDim) {
        multiplierOverlay.tint = 0x555555;
      } else {
        multiplierOverlay.tint = 0xffffff;
      }
    }

    dimMultiplier(row) {
      const multiplierOverlay = this._multiplierOverlays[row];
      multiplierOverlay.alpha = 0.5;
    }

    resetMultipliers() {
      this._multiplierOverlays.forEach((multi) => {
        multi.alpha = 1;
      });
    }

    clearDimSymbolIds(duration) {
      super.clearDimSymbolIds(duration);

      for (let i = 0; i < this._cashOverlays.length; ++i) {
        this._cashOverlays[i].normal.scale.set(1.0);
        this._cashOverlays[i].grey.scale.set(1.0);
      }
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisualSCS(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      0,
      numPreapp,
      numPostapp,
      gameController.dynamicSpinner,
      json.nudgeReel
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    reelSpinnerVisual.createBackgrounds();
    reelSpinnerVisual.createCashOverlays();
    reelSpinnerVisual.createMultiplierOverlays();
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType("ReelSpinnerVisualSCS", create, initialise, getRequiredFiles);
})();
